<!--
 * @Author: chenyingxuan chenyingxuan@abc.com
 * @Date: 2020-10-09 09:26:15
 * @LastEditors: chenyingxuan chenyingxuan@abc.com
 * @LastEditTime: 2024-01-09 14:20:18
 * @FilePath: /platform/src/views/uc/ReportLine.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <el-container class="fullheight" style="border: 1px solid #eee;margin-top: 16px;height: calc(100% - 20px)">
    <fe-aside-tree
      cat-id="12"
      :has-navbar-collapse="false"
      @node-click="handleNodeClick"
      :hasFooter="false"
    />
    <el-container>
      <report-line-aside-tree
        style="width:250px"
        :type-id="typeId"
        :has-navbar-collapse="false"
        v-if="isLineTreeShow"
      />
    </el-container>
  </el-container>
</template>
<script>
import portalApi from "@/api/portal.js";
const reportLineAsideTree = () =>
  import("@/views/uc/reportlinetree/ReportLineAsideTree.vue");
const FeAsideTree = () => import("@/components/common/FeAsideTree.vue");
export default {
  components: {
    reportLineAsideTree,
    FeAsideTree
  },
  data() {
    return {
      catId: "",
      options: [],
      typeId: "",
      isLineTreeShow: false
    };
  },
  computed: {},
  mounted() {
    // this.handleSelectOptions();
  },
  methods: {
    handleNodeClick(data) {
      console.log(data);
      if (data.parentId == 0) {
        this.$message.warning("请选择具体的汇报线分类");
        return;
      }
      this.isLineTreeShow = true;
      this.typeId = data.id;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
